<div class="pl-md-5 pr-md-5 masthead bg-white" [ngClass]="{'pt-4 pb-4': !tabs, 'pt-2 pb-2': tabs}">
    <div class="row justify-content-between align-items-center m-0">
        <div>
        	<p class="mb-0 h3 d-inline-block">
	            <i [ngClass]="headingClass" class="fa mr-3"></i>
	             <span *ngFor="let breadcrumb of breadcrumbs">
                    <a class="text-info" routerLink="/{{breadcrumb.url}}">
                        {{breadcrumb.title}}
                    </a>
                    <i class="fa fa-angle-right ml-1 mr-1 text-muted"></i>
                </span>
                <span>
                    {{pageTitle}}
                </span>
	        </p> 
            <div *ngIf="tabs" class="d-inline-block">
                <ul class="nav nav-tabbed">
                    <li class="nav-item" 
                        *ngFor="let tab of tabs" 
                        [routerLink]="tab?.path" 
                        routerLinkActive="active">
                        <a class="nav-link">{{tab?.data.title}}</a>
                    </li>
                </ul>
            </div>
		</div>
        <div *ngIf="!tabs">
	        <ng-container  *ngFor="let item of buttons; let i = index">
	            <button id="i" class="btn btn-primary ml-2 btn-sm" (click)="onButtonClick(i)" *ngIf="item.label.length > 0 && !item.disable">{{item.label}}<i [ngClass]="item.btnClass" class="ml-3"></i></button>
	        </ng-container>
	    </div>
    </div> 
</div>